require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/fn/object/assign.js
// module id = 94
// module chunks = 0